/**
 * @license
 * @copyright Copyright Motili Inc., 2025 All Rights Reserved
 */

import {
    DOCUMENT_TYPE,
    ORDER_TYPE,
} from 'common/stores/redux/MetaStore/MetaStoreApi.types';
import { Options } from 'admin/stores/redux/AdminOrderCreation/interfaces';
import { Order } from 'common/types/orders';

export const initializeOrder = (options: Options): Partial<Order> => {
    const { uuid, opsJobManager = undefined } = options;

    return {
        uuid,
        clientId: undefined,
        documentTypeId: DOCUMENT_TYPE.ORDER,
        orderTypeId: ORDER_TYPE.ORDER,
        instructions: {
            special: '',
        },
        fulfillmentDistributionCenterId: undefined,
        fulfillmentTo: '',
        fulfillmentToAddress: '',
        fulfillmentToCity: '',
        fulfillmentToPostalCode: '',
        fulfillmentToRegion: '',
        tradeTypeId: undefined,
        tradeSubTypeId: undefined,
        priorityId: undefined,
        statusId: undefined,
        contacts: [],
        extReferenceNumber1: '',
        extReferenceNumber2: '',
        extPoNumber: '',
        lineItems: [],
        job: {
            workOrders: [],
            number: undefined,
            project: {
                name: '',
            },
            notes: [],
        },
        opsJobManager,
        contractorId: undefined,
        hasFulfillmentMethods: false,
        fulfillmentMethod: undefined,
        propertyRequired: false,
        propertyDisplay: undefined,
        propertyId: undefined,
        enableDisplayAvailableStockOption: false,
        enableDisplayAHRIFilter: false,
        payeeOperationInCountry: undefined,
    };
};
